
export type TSection = {
    title: string;
    data: string;
}

type TMiniCardsProps = {
    sections: TSection[];
}

const BASE_CLASS = "miniCards"
const MiniCards: React.FC<TMiniCardsProps> = ({ sections }) => {
    const localTheme = window.localStorage.getItem("theme") || "light";

    return (
        <div className={BASE_CLASS}>
            {sections.map((section: TSection) => 
                <div key={section.title} className={`${BASE_CLASS}__card__container ${localTheme}`}>
                    <div className={`${BASE_CLASS}__title__container`}>
                        <h5>{section.title.toUpperCase()}</h5>
                    </div>
                    <div className={`${BASE_CLASS}__data__container`}>
                        <h5>{section.data}</h5>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MiniCards;